<svg *ngIf="selected" class="select-option-icon" [climbIcon]="icons.checkmark" size="sm"></svg>
<span class="option-text" #text><ng-content></ng-content></span>
